import { render, staticRenderFns } from "./SeriesForm.vue?vue&type=template&id=1c2322c7&"
import script from "./SeriesForm.vue?vue&type=script&lang=js&"
export * from "./SeriesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports